module.exports = __webpack_public_path__ + "img/hyl_what.50ca7164.png";